import React, { Component } from 'react'
import { TABLA_DETALLE_POR_CONDICION_LINEA_12 } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export class TablaDetallePorCondicionLinea12View extends Component {
  render () {
    return (
      <MuiTable id={TABLA_DETALLE_POR_CONDICION_LINEA_12} />
    )
  }
}
